import { type PaperProps } from '@mui/material/Paper';
import Box from '@mui/material/Box';
import React from 'react';
import { ScrollBox } from '../../features/index.ts';
import { useTheme } from '@mui/material';


type MenuPaperProps = PaperProps & { footer?: React.ReactNode };

export const MenuPaper = React.forwardRef<HTMLDivElement, MenuPaperProps>((props, ref) => {
  const { footer, children, sx, ...rest } = props;
  const theme = useTheme();
  return (
    <Box
      ref={ref}
      {...rest}
      sx={{
        borderRadius: theme.spacing(4),
        overflow: 'hidden',
        border: `1px solid ${theme.palette.accent}`,
        bgcolor: theme.palette.white_100,
        fontSize: '14px',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        overflowX: 'hidden',
        mt: 2,
        maxHeight: 300,
        '& .MuiMenu-list, & .MuiAutocomplete-listbox': {
          gap: 1,
          py: 0,
          '.checkSvg': {
            alignSelf: 'start',
            borderRadius: '50%',
            height: '24px',
            visibility: 'hidden',
            pointerEvents: 'none',
            width: '24px',
            marginLeft: 2,
            color: theme.palette.dark,
            background: theme.palette.white_100,
          },
        },
        '& .MuiMenuItem-root': {
          color: theme.palette.dark,
          mt: 1,
          '&:first-of-type': {
            mt: 0,
          },
          '& .not-display-in-menu': { display: 'none' },

          '&.Mui-selected': {
            // color: theme.palette.white_100,
            backgroundColor: 'inherit !important',
            '.checkSvg': {
              visibility: 'visible',
              opacity: 1,
            },
            '&:hover, &.Mui-focusVisible': {
              backgroundColor: `${theme.palette.accent} !important`,
            },
          },
          '&.MuiAutocomplete-option[aria-selected="true"]': {
            backgroundColor: 'inherit !important',
            '.checkSvg': {
              visibility: 'visible',
              opacity: 1,
            },
          },
          '&:hover, &.Mui-focusVisible, &.Mui-focused, &.MuiAutocomplete-option.Mui-focused, &.MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
            color: theme.palette.white_100,
            span: {
              color: `${theme.palette.white_100} !important`,
            },
            '.MuiTypography-root': {
              color: `${theme.palette.white_100} !important`,
            },
            backgroundColor: `${theme.palette.accent} !important`,
          },
          fontSize: '14px',
          py: 3,
          px: 4,
          borderRadius: theme.spacing(2),
          display: 'flex',
          justifyContent: 'space-between',
        },
        ...sx,
      }}
    >
      <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', maxHeight: 300 }}>
        <ScrollBox sx={{ overscrollBehavior: 'contain', pr: 2 }}>
          {children}
        </ScrollBox>

        {footer ? (
          <Box sx={{ display: 'flex', gap: 2, mt: 2, pt: 2 }}>
            {footer}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
});

MenuPaper.displayName = 'MenuPaper';
